import { ValidationFeedback } from '@ohpen/enso-ui';

// Row-level errors have no cell of their own; the grid shows them in this column.
export const ROW_ERRORS_COLUMN_KEY = '__row_errors__';

/** Errors per row number: one for every cell with errors, and one when the row has errors of its own. */
export const getRowsErrorsCount = (validationFeedback: ValidationFeedback | null): Record<string, number> =>
  Object.entries(validationFeedback ?? {}).reduce<Record<string, number>>((acc, [rowNumber, rowFeedback]) => {
    const cellsWithErrors = Object.values(rowFeedback.cellsFeedback ?? {}).filter(cell => cell.errors?.length).length;
    acc[rowNumber] = cellsWithErrors + (rowFeedback.errors?.length ? 1 : 0);
    return acc;
  }, {});

/** Rows with errors per column key, row-level errors counted under ROW_ERRORS_COLUMN_KEY. Columns without errors are left out. */
export const getColumnsErrorsCount = (validationFeedback: ValidationFeedback | null): Record<string, number> =>
  Object.values(validationFeedback ?? {}).reduce<Record<string, number>>((acc, rowFeedback) => {
    Object.entries(rowFeedback.cellsFeedback ?? {})
      .filter(([, cell]) => cell.errors?.length)
      .forEach(([columnKey]) => {
        acc[columnKey] = (acc[columnKey] ?? 0) + 1;
      });
    if (rowFeedback.errors?.length) acc[ROW_ERRORS_COLUMN_KEY] = (acc[ROW_ERRORS_COLUMN_KEY] ?? 0) + 1;
    return acc;
  }, {});
